import {Organization,} from '../types';
import {PlatformPropertyCard} from "@flexinet/ui-components";
import {Stack} from '@mantine/core';
import {NavLink} from 'react-router-dom';


export const Profile = ({record}: { record: Organization }) => {

    const properties = [
        {
            label: 'Name',
            value: record.name as string,
            span: 12,
        }, {
            label: 'Admin Account',
            value: <NavLink to={`/accounts/${record.adminAccountId}`}>{record.adminAccountId}</NavLink>,
            span: 12,
        }, {
            label: 'URL',
            value: record.url as string,
            span: 12,
        }, {
            label: 'Description',
            value: record.description as string,
            span: 12,
        }, {
            label: 'Email Address',
            value: record.email as string,
            span: 12,
        }, {
            label: 'Phone Number',
            value: record.phone as string,
            span: 12,
        }];

    const properties2 = [
        {
            label: 'Created By',
            value: typeof record.createdBy !== 'undefined' && record.createdBy !== null ? [record.createdBy.givenName, record.createdBy.familyName].join(' ') : 'n/a',
            rbac: 'UpdateOrganization',
            span: 12,
        },
        {
            label: 'Created',
            value: record.created as string,
            formatAs: 'Timestamp',
            span: 12,
        },
        {
            label: 'Last Updated',
            value: record.updated as string,
            formatAs: 'Timestamp',
            span: 12,
        }];

    return (
        <Stack gap={'xl'}>
            <PlatformPropertyCard properties={properties}/>
            <PlatformPropertyCard properties={properties2}/>
        </Stack>
    );


};


